import { onCleanup, onMount } from 'solid-js'

export default function onVisualViewportEvent<K extends keyof VisualViewportEventMap>(
  name: K,
  fn: (this: HTMLElement, ev: VisualViewportEventMap[K]) => void | null | boolean,
  options?: boolean | AddEventListenerOptions
): void {
  const { visualViewport } = window

  if (visualViewport) {
    onMount(() => {
      visualViewport.addEventListener(name, fn, options)
    })
    onCleanup(() => {
      // the if statement is necessary because elem can become null
      // after the fact, despite being a valid reference earlier.
      if (visualViewport) {
        visualViewport.removeEventListener(name, fn, options)
      }
    })  
  }
}
